import React from "react";
import PropTypes from "prop-types";
import { Grid, AppBar, Tabs, Tab, Box } from "@material-ui/core";
import useStyles from "./styles";

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<Grid
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box style={{ overflow: "hidden" }}>
					<Grid>{children}</Grid>
				</Box>
			)}
		</Grid>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired
};

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`
	};
}

const MenuLoyalty = props => {
	const classes = useStyles();
	const { menuLoyalty, value, handleChange } = props;

	return (
		<Grid className={classes.root}>
			<AppBar position="static" classes={{ root: classes.rootAppBar }}>
				<Tabs
					value={value < 0 ? 0 : value}
					onChange={handleChange}
					aria-label="simple tabs example"
					classes={{ root: classes.rootTabs }}
					TabIndicatorProps={{
						style: {
							backgroundColor: "#00000000"
						}
					}}
				>
					{menuLoyalty.map((item, index) => (
						<Tab
							key={index}
							label={item.label}
							{...a11yProps(index)}
							style={{
								background:
									value === index && item.backgroundColor,
								opacity: 1,
								borderRadius: `${
									index === 0 ? 8 : value === index ? 8 : 0
								}px ${index === value - 1 ? 0 : 8}px 0px 0px`,
								marginLeft: index === 0 ? 0 : -8,
								zIndex:
									value === index
										? value + menuLoyalty.length
										: menuLoyalty.length - index
							}}
							classes={{
								root: classes.rootTab,
								selected: classes.selected
							}}
						/>
					))}
				</Tabs>
			</AppBar>
			{menuLoyalty.map((item, index) => (
				<TabPanel key={index} value={value} index={index}>
					{item.component}
				</TabPanel>
			))}
		</Grid>
	);
};

export default MenuLoyalty;
